var React = require('react');

function BubbleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51.5627 0C27.8314 0 8.59332 19.2518 8.59332 43C8.59332 43.9964 8.62714 44.9848 8.69379 45.9643C8.81537 51.6888 8.93576 64.3036 7.86646 71.1572C7.02185 76.5706 3.31235 80.8323 0.466309 83.384C-0.475952 84.2288 0.104401 85.9031 1.36163 85.7619C6.74326 85.1574 16.2105 83.254 24.3495 77.2719C24.5677 77.1115 24.7731 76.9458 24.966 76.7751C32.282 82.5523 41.52 86 51.5627 86H428.031C451.762 86 471 66.7482 471 43C471 19.2518 451.762 0 428.031 0H51.5627Z","fill":"#327CFF"}));
}

BubbleInline.defaultProps = {"width":"20","height":"40","viewBox":"0 46 20 40","fill":"none"};

module.exports = BubbleInline;

BubbleInline.default = BubbleInline;
